<template>
  <div id="api-key" class="layout-wrapper api-key">
      <v-card class="light-card">
        <v-toolbar color="primary" id="toolbar">
          <v-card-title class="top-title">Downloads</v-card-title>
          <v-spacer />
          <div class="d-flex align-baseline w-100">
            <div>
              <v-text-field
                v-model="search"
                prepend-inner-icon="search"
                label="Search"

                class="select-field  mt-4"
                single-line
                hide-details
                @keyup.native="filterApiKeys"
              />
            </div>
            <v-spacer></v-spacer>
            <v-btn class="primary-btn px-6"
              depressed
              @click="$router.push('/api_keyeditor/new')"
            >
              Create Key
            </v-btn>
          </div>
        </v-toolbar>
        <v-spacer></v-spacer>
        <v-data-table
          :headers="headers"
          :items="filtered_api_keys"
          :options.sync="options"
          item-key="entity_id"
          class="light-table"
          hide-default-footer
        >
          <template v-slot:body="{ items }">
            <tbody>
            <tr
              v-for="item in items"
              :key="item.entity_id"
            >
              <td>
                <div class="d-flex">
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on">
                        <v-btn
                          text
                          icon
                        >
                          <v-icon
                            :color="theme.tabelEnteries"
                            dark
                            :class="'ml-auto'"
                            v-bind="attrs"
                          >
                            {{ 'cloud_download' }}
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list class="api-key-edit api-context-menu-custom">
                      <v-list-item
                        key="cloud_collector_download_windows"
                        @click="actionDownloadWindowsCloudCollector.action(item.key)"
                        :disabled="!item.download_available"
                      >
                        <v-list-item-title class="mr-2">Cloud Collector - Windows <span class="ml-1" v-show="!item.download_available">(building...)</span></v-list-item-title>
                        <img class="azure-logo" style="max-width: 20px; max-height: 25px;" :src="require(`@/assets/img/menu/${actionDownloadWindowsCloudCollector.icon}`)" />
                      </v-list-item>
                      <v-list-item
                        key="processing-cluster-windows"
                        @click="actionDownloadWindowCluster.action(item.key)"
                         v-if="enableProcessingCluster"
                      >
                        <v-list-item-title class="mr-2">Processing Cluster - Windows </v-list-item-title>
                        <img class="azure-logo" style="max-width: 20px; max-height: 25px;" :src="require(`@/assets/img/menu/${actionDownloadWindowCluster.icon}`)" />
                      </v-list-item>
                      <v-list-item
                        :key="'on_premise_collector_download'+item.download_available"
                        @click="actionDownloadCollector.action(item.key)"
                        :disabled="!item.download_available"
                      >
                        <v-list-item-title class="mr-2">On-Premise Collector <span class="ml-1" v-show="!item.download_available">(building...)</span></v-list-item-title>
                        <img class="azure-logo" style="max-width: 20px; max-height: 25px;" :src="require(`@/assets/img/menu/${actionDownloadCollector.icon}`)" />
                      </v-list-item>
                      <v-list-item
                        key="cloud-collector-docker "
                        @click="actionDownloadCloudCollector.action(item.key)"
                        :disabled="!item.download_available"
                      >
                        <v-list-item-title class="mr-2">Cloud Collector - Docker <span class="ml-1" v-show="!item.download_available">(building...)</span></v-list-item-title>
                        <img class="azure-logo" style="max-width: 25px; max-height: 25px;" :src="require(`@/assets/img/menu/${actionDownloadCloudCollector.icon}`)"/>
                      </v-list-item>
                      <v-list-item
                        key="processing-cluster-docker"
                        @click="actionDownloadCluster.action(item.key)"
                         v-if="enableProcessingCluster"
                      >
                        <v-list-item-title class="mr-2">Processing Cluster - Docker </v-list-item-title>
                        <img class="azure-logo" style="max-width: 25px; max-height: 25px;" :src="require(`@/assets/img/menu/${actionDownloadCluster.icon}`)" />
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </td>
              <td>
                {{ item.name }}
              </td>
              <td>{{item.key}}</td>
              <td :class="item.status ? 'active' : 'deactive'"><span>{{ collectorStatus(item) }}</span></td>
              <td>{{ item.last_used }}</td>
              <td>{{formatDate(item.changed_on)}}</td>
              <td>
                <div class="d-flex">
                  <v-tooltip
                    bottom
                    v-for="(btn, index) in actionButtons"
                    :key="index"
                    :disabled="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on">
                        <v-btn
                          text
                          icon
                          :disabled="(btn.icon == 'cloud_download' && !item.download_available)"
                        >
                          <v-icon
                            :color="theme.tabelEnteries"
                            dark
                            :class="index === actionButtons.length - 1 ? 'ml-auto' : 'mr-2'"
                            class="material-icons-outlined"
                            v-bind="attrs"
                            @click="btn.action(item, btn.modal)"
                          >
                            {{ btn.icon }}
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span v-if="btn.icon == 'cloud_download' && !item.download_available">
                      We are building your installer
                     </span>
                    <span v-else>{{btn.name}}</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card>
    <!--    Confirm Delete dialog-->
    <v-dialog v-model="confrimDialog.open" persistent max-width="650">
      <v-card class="delete-dialog">
        <v-card-title class="headline dark--text">Please confirm</v-card-title>
        <v-card-text class="dark--text">{{ confrimDialog.text }} <strong>{{confrimDialog.name}}</strong>?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="cancel-btn" text @click="confrimDialog.open = false">Cancel</v-btn>
          <v-btn class="save-btn" text @click="confrimDialog.action(confrimDialog.argument)">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Api_key',
  computed: {
    ...mapGetters({
      api_keys: 'api_keys',
      filtered_api_keys: 'filtered_api_keys',
      currentOrganization: 'currentOrganization',
      theme: 'colorPaletteServices/theme',
      license: 'license'
    }),
    enableProcessingCluster () {
      return this.license && this.license.enable_processing_cluster && this.license.enable_processing_cluster == true
    }
  },
  created () {
    setTimeout(function () {
      const element = document.getElementsByClassName('api-key')[0]
      element && element.scrollIntoView(true)
    }, 1000)
  },
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Downloads',
          value: 'download',
          sortable: false
        },
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        {
          text: 'Key',
          value: 'entity_id',
          align: 'left'
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left'
        },
        {
          text: 'Last Used',
          value: 'last_used'
        },
        {
          text: 'Created',
          value: 'changed_on'
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ],
      actionDownloadCollector: {
        name: 'click to download installer',
        icon: 'window.png',
        action: this.download
      },
      actionDownloadCloudCollector: {
        name: 'click to download installer',
        icon: 'linux.png',
        action: this.downloadCloudCollector
      },
      actionDownloadWindowsCloudCollector: {
        name: 'click to download installer',
        icon: 'window.png',
        action: this.downloadWindowsCloudCollector
      },
      actionDownloadCluster: {
        name: 'click to download zip',
        icon: 'linux.png',
        action: this.downloadCluster
      },
      actionDownloadWindowCluster: {
        name: 'click to download zip',
        icon: 'window.png',
        action: this.downloadWindowCluster
      },
      actionButtons: [
        {
          name: 'Edit',
          icon: 'edit',
          action: this.handleEdit
        },
        {
          name: 'Delete',
          icon: 'delete',
          action: this.confirmModal,
          modal: {
            text: 'Are you want to delete',
            name: 'name',
            argument: 'entity_id',
            action: this.apiDelete
          }
        }],
      options: {
        page: 1,
        sortBy: ['changed_on'],
        itemsPerPage: Number.MAX_SAFE_INTEGER
      },
      confrimDialog: {
        open: false,
        name: '',
        text: '',
        argument: '',
        action: ''
      }
    }
  },

  methods: {
    confirmModal (item, modal) {
      this.confrimDialog = {
        open: true,
        text: modal.text,
        name: modal.name ? item[modal.name] : '',
        argument: item[modal.argument],
        action: modal.action
      }
    },
    apiDelete (id) {
      this.resetConfrimDialog()
      this.$store.dispatch('deleteApi_key', id)
    },
    formatDate (value) {
      return value ? this.$moment(value, 'YYYY-MM-DD').format('MMM DD, YYYY') : ''
    },
    collectorStatus (item) {
      if (item.status && !item.download_available) return 'Building Collectors'
      else return item.status ? 'Activated' : 'Deactivated'
    },
    filterApiKeys () {
      if (!this.search) {
        this.$store.commit('setFilteredApiKeys', [...this.api_keys])
        return
      }
      const filteredApiKeys = this.api_keys.filter(item => {
        return item.name.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase()) !== -1
      })
      this.$store.commit('setFilteredApiKeys', filteredApiKeys)
    },
    resetConfrimDialog () {
      this.confrimDialog = {
        open: false,
        name: '',
        text: '',
        argument: '',
        action: ''
      }
    },
    download (apiKey) {
      this.$mixpanel.track('Installer Downloaded')
      const url = process.env.VUE_APP_STATIC + '/builds/' + this.currentOrganization.entity_id +
                '/' + apiKey + '/reveles-collector-setup.exe'
      window.open(url, '_blank')
    },
    downloadCloudCollector (apiKey) {
      this.$mixpanel.track('Docker Cloud Collector Downloaded')
      const url = process.env.VUE_APP_STATIC + '/builds/' + this.currentOrganization.entity_id +
                '/' + apiKey + '/docker-install.zip'
      window.open(url, '_blank')
    },
    downloadWindowsCloudCollector (apiKey) {
      this.$mixpanel.track('Windows Cloud Collector Downloaded')
      const url = process.env.VUE_APP_STATIC + '/builds/' + this.currentOrganization.entity_id +
        '/' + apiKey + '/reveles-cloud-collector-setup.exe'
      window.open(url, '_blank')
    },
    downloadCluster (apiKey) {
      this.$mixpanel.track('Cluster Zip Downloaded')
      const url = process.env.VUE_APP_STATIC + '/builds/' + this.currentOrganization.entity_id +
                '/' + apiKey + '/mgmt-install.zip'
      window.open(url, '_blank')
    },
    downloadWindowCluster (apiKey) {
      this.$mixpanel.track('Windows Cluster Zip Downloaded')
      const url = process.env.VUE_APP_STATIC + '/builds/' + this.currentOrganization.entity_id +
                '/' + apiKey + '/reveles-collector-management-setup.exe'
      window.open(url, '_blank')
    },
    handleEdit (item) {
      this.$router.push({ name: 'api_keyeditor', params: { id: item.entity_id, api_item: item } })
    }
  }
}
</script>

<style lang="scss">
  .desktop-arrow-downward {
    position: absolute !important;
    left: 12px !important;
    top: -4px !important;
    font-size: 14px !important;
    font-weight: 900 !important;
  }
  .v-menu__content {
    .api-context-menu-custom {
      &.api-key-edit {
        width: 100% !important;
        max-width: 320px;
      }
    }
  }
  .api-context-menu-custom .v-list-item.v-list-item--disabled {
    &:before {
      background-color: currentColor;
      bottom: 0;
      content: "";
      left: 0;
      opacity: 0.1;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
      -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      &:hover {
        background: rgba(0, 0, 0, 0.87)
      }
    }
  }
</style>
